module.exports = __webpack_public_path__ + "static/inkblot-logo-dark-blue-633d82e9f0fc9e7bf1edf4d469aaf8ec.svg";